import { Icon, Tooltip } from "@mui/material";
import MDBox from "components/MDBox";
import { WorksheetProduct } from "generated/graphql";
import useDeleteWorksheetProduct from "hooks/worksheetProducts/useDeleteWorksheetProduct";
import { draftColors } from "modules/proposals/draft/draftDesignTokens";
import { Link } from "react-router-dom";
import { getRoute } from "utils/routing";

export default function WorksheetProductActionsCell({
  product,
  productTypeId,
  onArchived,
}: {
  product: WorksheetProduct;
  productTypeId: string;
  onArchived: () => void;
}) {
  const [deleteWorksheetProduct] = useDeleteWorksheetProduct();

  const handleArchive = async () => {
    await deleteWorksheetProduct({ variables: { id: product.id } });
    onArchived();
  };

  return (
    <MDBox display="flex" alignItems="center" justifyContent="center" gap="8px">
      <Tooltip title="Edit">
        <MDBox
          component={Link}
          to={getRoute("product-types.worksheet-products.update", [
            ["productTypeId", productTypeId],
            ["productId", product.id],
          ])}
          sx={{ color: draftColors.textAction, display: "flex" }}
        >
          <Icon fontSize="small">edit</Icon>
        </MDBox>
      </Tooltip>
      <Tooltip title="Archive">
        <Icon
          fontSize="small"
          sx={{ cursor: "pointer", color: draftColors.red }}
          onClick={handleArchive}
        >
          archive
        </Icon>
      </Tooltip>
    </MDBox>
  );
}
